import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";
import { api } from "@/lib/api";

const spans = [
  "md:col-span-2 md:row-span-2 aspect-square",
  "aspect-[4/5]",
  "aspect-[4/5]",
  "aspect-[4/5]",
  "aspect-[4/5]",
  "md:col-span-2 aspect-[16/9]",
];

// Photos stored with wrong orientation — rotate -90deg to display upright.
// Match by the unique artifact prefix in the URL.
const ROTATE_FIXES = { ekvjv5ru: "-90deg" };

const rotationFor = (src = "") => {
  for (const [key, deg] of Object.entries(ROTATE_FIXES)) {
    if (src.includes(key)) return deg;
  }
  return null;
};

export default function Gallery() {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-icdh-surface py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal><Overline>{t.gallery.overline}</Overline></Reveal>
        <Reveal delay={0.1}><h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight text-icdh-navy max-w-2xl">{t.gallery.title}</h2></Reveal>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-auto">
          {items.map((g, i) => {
            const rotate = rotationFor(g.image);
            return (
              <Reveal key={g.id} delay={(i % 4) * 0.08} className={spans[i % spans.length]}>
                <div data-testid={`gallery-item-${i}`} className="group relative overflow-hidden h-full w-full">
                  <img
                    src={g.image}
                    alt={g.caption?.[lang] || ""}
                    style={rotate ? { transform: `rotate(${rotate})`, transformOrigin: "center" } : undefined}
                    className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-[900ms]"
                  />
                  <div className="absolute inset-0 bg-icdh-navy/0 group-hover:bg-icdh-navy/40 transition-colors duration-500 flex items-end p-5">
                    <span className="text-icdh-white font-serif italic text-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500">{g.caption?.[lang]}</span>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
